
import { defineComponent, toRefs, reactive } from 'vue'
import Icon from '@/components/base/Icon.vue'
import { IconType } from '@/enums/IconType'
import AdaptiveWindowLayout from '@/layouts/AdaptiveWindowLayout.vue'
import Button, { ButtonThemeStyle, ButtonSizeStyle } from '@/components/base/Button.vue'
import ButtonRack, { ButtonRackDirectionType } from '@/components/base/ButtonRack.vue'
import Calendar from '@/components/base/Calendar.vue'
import Tabs, { TabType } from '@/components/base/Tabs.vue'
import Input from '@/components/base/controls/Input.vue'
import Checkbox, { CheckboxSizeType, CheckboxType } from '@/components/base/controls/Checkbox.vue'
import Table, { baseTableHeader } from '@/components/base/Table.vue'
import Accordion from '@/components/base/Accordion.vue'
import DateRangePicker from '@/components/composite/DateRangePicker.vue'
import SelectAndSearch from '@/components/base/controls/SelectAndSearch.vue'
import SearchInput from '@/components/base/controls/SearchInput.vue'
import Check from '@/components/base/controls/Check.vue'
import moment from 'moment'
import store, { MutationName } from '@/store'

export default defineComponent({
  components: {
    Icon,
    AdaptiveWindowLayout,
    Button,
    ButtonRack,
    Calendar,
    Table,
    Tabs,
    Input,
    Checkbox,
    Accordion,
    DateRangePicker,
    SelectAndSearch,
    SearchInput,
    Check,
  },
  setup() {
    const state = reactive({
      tabIndex1: 0,
      tabIndex2: 0,
      tabItems1: [
        {
          name: '입고정리',
          content: '스마트락 라이트 전원, 스마트락 안열림',
        },
        {
          name: '재배치',
          content: '성남하남 창고 (11)',
        },
      ],
      tabItems2: [
        {
          name: '전장품 스마트락',
          content: '사용 부품 없음',
        },
        {
          name: '교체 스마트락',
          content: '교체 탭',
        },
        {
          name: '차체 관련',
          content: '수리 필요 없음',
        },
        {
          name: '이 외 기타',
          content: '휠셋 - 뒤 (프리휠 포함)',
        },
      ],
      checkboxItems1: [
        {
          id: 'banana',
          value: 'banana',
        },
        {
          id: 'cherry',
          value: 'cherry',
        },
        {
          id: 'apple',
          value: 'apple',
        },
        {
          id: 'melon',
          value: 'melon',
        },
      ],
      checkboxItems2: [
        {
          id: 'a',
          value: 'a',
        },
        {
          id: 'b',
          value: 'b',
        },
        {
          id: 'c',
          value: 'c',
        },
        {
          id: 'd',
          value: 'd',
        },
      ],
      checkedNames1: [],
      checkedNames2: [],
      username: '',
      password: '',
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
    })
    return {
      ...toRefs(state),
      IconType,

      ButtonThemeStyle,
      ButtonSizeStyle,
      ButtonRackDirectionType,
      onToast: () => {
        return store.commit(MutationName.SET_TOAST, { message: '토스트 테스트', show: true })
      },
      disableCalendarPrevButtonFunc: (date: string) => {
        return date < '2020-11-01'
      },
      tableData: {
        headers: [
          Object.assign({}, baseTableHeader, { id: 'a', name: '아이디', width: '100px', flexGrow: 1, textAlign: null }),
          Object.assign({}, baseTableHeader, { id: 'b', name: '배터리', width: '60px', enableDescendingSort: true }),
          Object.assign({}, baseTableHeader, { id: 'c', name: '입고', width: '60px', enableDescendingSort: true }),
          Object.assign({}, baseTableHeader, { id: 'd', name: '현장', width: '60px', enableDescendingSort: true }),
          Object.assign({}, baseTableHeader, { id: 'e', name: '상차', width: '60px', enableDescendingSort: true }),
          Object.assign({}, baseTableHeader, { id: 'f', name: '하차', width: '60px', enableDescendingSort: true }),
        ],
        data: [
          { a: 'CA1234CA1234CA1234CA1234CA1234CA1234CA1234CA1234', b: 98, c: 3, d: 4, e: 5, f: 6 },
          { a: 'CA1234', b: 98, c: 1, d: 4, e: 5, f: 6 },
          { a: 'CA1234', b: 97, c: 2, d: 4, e: 5, f: 6 },
          { a: 'CA1234', b: 96, c: 3, d: 4, e: 5, f: 6 },
          { a: 'CA1234', b: 95, c: 4, d: 4, e: 5, f: 6 },
          { a: 'CA1234', b: 94, c: 5, d: 4, e: 5, f: 6 },
          { a: 'CA1234', b: 93, c: 6, d: 4, e: 5, f: 6 },
          { a: 'CA1234', b: 92, c: 7, d: 4, e: 5, f: 6 },
          { a: 'CA1234', b: 91, c: 8, d: 4, e: 5, f: 6 },
          { a: 'CA1234', b: 90, c: 9, d: 4, e: 5, f: 6 },
        ],
      },
      accordionData: [
        {
          name: '수리 부품 확인 1111',
          items: [{ text: '사용 부품 없음' }, { text: '수리 필요 없음' }, { text: '사용 부품 없음' }],
        },
        {
          name: '수리 부품 확인 2222',
          items: [{ text: '사용 부품 없음' }, { text: '수리 필요 없음' }, { text: '수리 필요 없음' }],
        },
      ],
      TabType,
      CheckboxSizeType,
      CheckboxType,
    }
  },
})
